import { getCompany, getConnector, getTaskAndTaskWorkflow, getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createDepositSwitchRemovedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.DEPOSIT_SWITCH_REMOVED,
        ...getUserAndEventTime(),
        ...getTaskAndTaskWorkflow(),
        data: {
            removedDepositAccount: {
                routingNumber: '456456456',
                accountNumber: 'XXXX1111',
                type: 'savings',
                bankName: 'Molecular Bank',
                distributionType: 'percent',
                distributionAmount: 20
            },
            depositAccounts: [
                {
                    routingNumber: '123123123',
                    accountNumber: '1122330000',
                    type: 'checking',
                    bankName: 'Molecular Bank',
                    distributionType: 'percent',
                    distributionAmount: 100
                }
            ],
            ...getCompany(),
            ...getConnector(),
            linkedAccount: '5f7212103a40e91f95ba376d'
        }
    };
};
//# sourceMappingURL=deposit-switch-removed.js.map